import { APP_VERSION } from '../version';
import styles from './SiteFooter.module.css';

const year = new Date().getFullYear();

export function SiteFooter({ className }: { className?: string }) {
  return (
    <footer className={`${styles.footer} ${className ?? ''}`.trim()}>
      <div className={styles.footerInner}>
        <div className={styles.footerInnerLeft}>
          <span>
            &copy; {year} Halfmeyer Ventures
          </span>
          <span className={styles.footerVersion}>v{APP_VERSION}</span>
        </div>
        <div className={styles.footerInnerLinks}>
          <a href="https://halfmeyer.com/privacy.html" target="_blank" rel="noopener noreferrer">
            Privacy
          </a>
          |&nbsp;
          <a href="https://halfmeyer.com/imprint.html" target="_blank" rel="noopener noreferrer">
            Imprint
          </a>
        </div>
      </div>
    </footer>
  );
}
